import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "h-screen flex flex-col items-center justify-center mx-4" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h2", { class: "text-primary font-bold text-xl" }, "Setup process vault", -1);
const _hoisted_3 = { class: "w-full flex flex-col justify-center" };
const _hoisted_4 = {
    key: 0,
    class: "w-full"
};
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { key: 2 };
const _hoisted_7 = { class: "grid grid-cols-4 pt-2 bg-gray-200" };
const _hoisted_8 = { class: "text-xs" };
const _hoisted_9 = { key: 3 };
const _hoisted_10 = { class: "grid grid-cols-3 pt-2" };
const _hoisted_11 = ["onChange"];
const _hoisted_12 = { key: 4 };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("h3", null, "App setup", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Form = _resolveComponent("Form");
    const _component_qr_code = _resolveComponent("qr-code");
    const _component_card = _resolveComponent("card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_card, {
            width: "32",
            heigth: "32",
            class: "container flex flex-row flex-wrap"
        }, {
            header: _withCtx(() => [
                _hoisted_2
            ]),
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                    (_ctx.step === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_component_Form, {
                                class: "mt-2 w-full",
                                "form-data": _ctx.form,
                                onSubmit: _ctx.validateFields
                            }, null, 8, ["form-data", "onSubmit"])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.step === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_Form, {
                                class: "mt-2",
                                "form-data": _ctx.usernameForm,
                                onSubmit: _ctx.validateUsername
                            }, null, 8, ["form-data", "onSubmit"])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.step === 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('invite.writeDownSeedPhrase')), 1),
                            _createElementVNode("div", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userDetails.seedPhrase.split(' '), (word, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: word + i,
                                        class: "text-center grid grid-cols-1 mb-2"
                                    }, [
                                        _createElementVNode("span", _hoisted_8, _toDisplayString(i + 1), 1),
                                        _createElementVNode("span", null, _toDisplayString(word), 1)
                                    ]));
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.step === 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('invite.controlWords')), 1),
                            _createElementVNode("div", _hoisted_10, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.randomWordIndexes, (wordIndex, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: "px-2",
                                        key: wordIndex + i
                                    }, [
                                        _createTextVNode(" Word " + _toDisplayString(wordIndex + 1) + " ", 1),
                                        _createElementVNode("input", {
                                            class: "py-0 my-0",
                                            onChange: event => (_ctx.filledWords[i] = event.target.value)
                                        }, null, 40, _hoisted_11)
                                    ]));
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.step === 4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('setup.appSetup')), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.appUrl), 1),
                            (!_ctx.isMobile())
                                ? _withDirectives((_openBlock(), _createBlock(_component_qr_code, {
                                    class: "m-auto",
                                    size: 200,
                                    level: "H",
                                    value: _ctx.appUrl,
                                    key: _ctx.appUrl
                                }, null, 8, ["value"])), [
                                    [_vShow, _ctx.setupDetails]
                                ])
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.openAppUrl())),
                                    class: "capitalize"
                                }, _toDisplayString(_ctx.$t('setup.openApp')), 1))
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            actions: _withCtx(() => [
                (_ctx.step === 2)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "bg-primary text-white capitalize",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.nextStep()))
                    }, _toDisplayString(_ctx.$t('misc.next')), 1))
                    : _createCommentVNode("", true),
                (_ctx.step === 3)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "bg-primary text-white capitalize",
                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.processSetup()))
                    }, _toDisplayString(_ctx.$t('misc.next')), 1))
                    : (_ctx.step === 4)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "bg-primary text-white capitalize",
                            onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.proceedToSelection()))
                        }, _toDisplayString(_ctx.$t('misc.next')), 1))
                        : _createCommentVNode("", true)
            ]),
            _: 1
        })
    ]));
}
